import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=6f46ef84&"
import script from "./ErrorView.vue?vue&type=script&lang=ts&"
export * from "./ErrorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports